// Google Analytics utility functions

export const GA_TRACKING_ID = process.env.REACT_APP_GA_ID || '';

// Initialize Google Analytics
export const initGA = () => {
  if (!GA_TRACKING_ID) {
    console.log('Google Analytics ID not configured');
    return;
  }

  // Load GA script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', GA_TRACKING_ID, {
    page_path: window.location.pathname,
  });

  window.gtag = gtag;
};

// Track page view
export const pageview = (url) => {
  if (!GA_TRACKING_ID || !window.gtag) return;

  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

// Track custom event
export const event = ({ action, category, label, value }) => {
  if (!GA_TRACKING_ID || !window.gtag) return;

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

// Track form submission
export const trackFormSubmit = (formName) => {
  event({
    action: 'form_submit',
    category: 'engagement',
    label: formName,
  });
};

// Track button click
export const trackButtonClick = (buttonName) => {
  event({
    action: 'button_click',
    category: 'engagement',
    label: buttonName,
  });
};

// Track phone call
export const trackPhoneCall = () => {
  event({
    action: 'phone_call',
    category: 'lead',
    label: 'phone_number_clicked',
  });
};

// Track WhatsApp click
export const trackWhatsAppClick = () => {
  event({
    action: 'whatsapp_click',
    category: 'lead',
    label: 'whatsapp_clicked',
  });
};
